import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { useHatm } from '../../context/HatmContext';
import { JuzGrid } from '../../styles/hatm.styles';
import JuzCard from './JuzCard';
import FilterBar from './FilterBar';
import { styled } from '@mui/material/styles';

const EmptyState = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  padding: '48px',
  background: '#F7E1D7',
  borderRadius: '16px',
  margin: '24px 0',
}));

const GridSection = styled(Box)(({ theme }) => ({
  position: 'relative',
  margin: '3px 0',
}));

export default function HatmGrid({ hatmId, auth, onRemoveParticipant }) {
  const { state, chosenJuzs, setChosenJuzs } = useHatm();
  const [filter, setFilter] = useState('all'); // 'all', 'available', 'selected', 'completed'

  const handleJuzClick = (index, hasData) => {
    if (hasData) return;

    setChosenJuzs(prev => {
      if (prev.includes(index)) {
        return prev.filter(juz => juz !== index);
      }
      return [...prev, index].sort((a, b) => a - b);
    });
  };

  const getFilteredJuzs = () => {
    let firstIncompleteFound = false;
    const juzs = Array.from({ length: 30 }, (_, i) => i + 1).map(index => {
      const isCompleted = state?.juzs?.[index];
      const isSelected = chosenJuzs.includes(index);
      const isFirstIncomplete = !firstIncompleteFound && !isCompleted;
      
      if (isFirstIncomplete) {
        firstIncompleteFound = true;
      }

      if (filter === 'available' && (isCompleted || isSelected)) return null;
      if (filter === 'selected' && !isSelected) return null;
      if (filter === 'completed' && !isCompleted) return null;
      
      return { index, isCompleted, isSelected, isFirstIncomplete };
    }).filter(Boolean);

    return juzs;
  };

  const filteredJuzs = getFilteredJuzs();

  return (
    <GridSection>
      <FilterBar 
        filter={filter} 
        setFilter={setFilter}
        totalJuzs={30}
        completedJuzs={Object.keys(state?.juzs || {}).length}
        selectedJuzs={chosenJuzs.length}
      />

      <AnimatePresence mode="wait">
        {filteredJuzs.length > 0 ? (
          <JuzGrid className="hatm-footer-juz-selection">
            {filteredJuzs.map(({ index, isCompleted, isSelected, isFirstIncomplete }) => (
              <JuzCard
                key={index}
                index={index}
                isSelected={isSelected}
                juzData={state?.juzs?.[index]}
                onClick={() => handleJuzClick(index, isCompleted)}
                onRemove={onRemoveParticipant}
                isCreator={auth.currentUser?.uid === state?.creator}
                isFirstIncomplete={isFirstIncomplete}
              />
            ))}
          </JuzGrid>
        ) : (
          <EmptyState
            as={motion.div}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
          >
            <Typography variant="h6">Bu kategoride cüz bulunamadı</Typography>
            <Typography variant="body2" color="text.secondary">
              Farklı bir kategori seçmeyi deneyin
            </Typography>
          </EmptyState>
        )}
      </AnimatePresence>
    </GridSection>
  );
} 